import axios from 'axios';
import {bindActionCreators} from 'redux';
import store from '../store.js'
import {setCurrentUser,setCurrentAccount} from '../actions/Login.js';

class Auth {
	static authenticate(token,account_id = false) {
		let state = store.getState();

		if(account_id != state.auth.currentAccount && account_id != false) {
			store.dispatch(setCurrentAccount(account_id));
		}

		if(!account_id) {
			account_id = state.auth.currentAccount;
		}

		if(!account_id && localStorage.getItem('last_account_id')) {
            account_id = localStorage.getItem('last_account_id');
            store.dispatch(setCurrentAccount(account_id));

            return {
				action:'redirect',
				url:'/dashboard',
			};
		}

        if(token) {
            axios.defaults.headers.common['Authorized-account'] = account_id;
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
		}else{
			delete axios.defaults.headers.common['Authorized-account'];
			delete axios.defaults.headers.common['Authorization'];
		}

		Auth.setToken(token);

		return true;
	}

	static isStaff() {
		return localStorage.getItem('is_staff');
	}

	static setToken(token) {
		if(token) {
			localStorage.setItem('crallAuthToken', token);
		}else{
			localStorage.removeItem('crallAuthToken');
		}
	}

	static getToken() {
		return localStorage.crallAuthToken || false;
	}
}

export default Auth;



// WEBPACK FOOTER //
// ./modules/Auth.js